import React, { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter, FaYoutube, FaPhone, FaEnvelope, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import { API_BASE } from '../../config/api';
import { bindStorefrontRefresh } from '../../utils/storefrontRefresh';
import './Footer.css';

const Footer = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [productCategories, setProductCategories] = useState([
    'BRASS-CZ-COLOR STONE',
    'SILVER-PLAIN',
    'SILVER- CZ-COLOR STONE',
    'SILVER-CVD (LGD)',
    'SILVER-NATURAL DIAMOND',
    'GOLD-PLAIN',
    'GOLD-CZ-COLOR STONE',
    'GOLD- CVD(LGD)',
    'GOLD-NATURAL DIAMOND',
    'PLATINUM-PLAIN',
    'PLATINUM-CVD (LGD)',
    'PLATINUM-NATURAL DIAMOND',
    'PLATINUM-GOLD-PLAIN',
    'PLATINUM-GOLD-STUDDED (LGD/NAT.)',
  ]);

  const fetchProductCategories = useCallback(() => {
    fetch(`${API_BASE}/navbar-dropdown`)
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data.jewelryMetals) && data.jewelryMetals.length) {
          setProductCategories(data.jewelryMetals);
        }
      })
      .catch(() => {});
  }, []);

  useEffect(() => {
    fetchProductCategories();
  }, [fetchProductCategories]);

  useEffect(() => bindStorefrontRefresh(fetchProductCategories, { scopes: ['navigation'] }), [fetchProductCategories]);

  // Handle newsletter subscription
  const handleNewsletterSubmit = (e) => {
    e.preventDefault();
    if (email.trim()) {
      // Here you can add the newsletter subscription logic
      alert('Thank you for subscribing to our newsletter!');
      setEmail('');
    }
  };

  // Handle product category navigation
  const handleProductClick = (category) => {
    navigate(`/store?material=${encodeURIComponent(category)}`);
  };

  // Handle quick links navigation
  const handleQuickLinkClick = (link) => {
    switch (link) {
      case 'products':
        navigate('/store');
        break;
      case 'about':
        navigate('/about');
        break;
      case 'bespoke':
        navigate('/bespoke-jewelry');
        break;
      case 'contact':
        navigate('/contact');
        break;
      case 'terms':
        navigate('/terms');
        break;
      default:
        break;
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Company Info */}
        <div className="footer-column">
          <div className="footer-logo">
            <h3><span className="brand-name-gold">Panchali Jewels</span></h3>
            <p>Your trusted partner in fine jewelry</p>
          </div>
          <p className="company-description">
            Discover exquisite jewelry crafted with precision and passion. From traditional designs to modern elegance, we bring you the finest collection of rings, necklaces, earrings, and more.
          </p>
          <div className="contact-info">
            <div className="contact-item">
              <FaPhone className="contact-icon" />
              <span>+91 96965 81515</span>
            </div>
            <div className="contact-item">
              <FaEnvelope className="contact-icon" />
              <span>support.panchalijewels@gmail.com</span>
            </div>
            <div className="contact-item">
              <FaMapMarkerAlt className="contact-icon" />
              <span>Mumbai, Maharashtra, India</span>
            </div>
          </div>
        </div>

        {/* Quick Links */}
        <div className="footer-column">
          <h4>Quick Links</h4>
          <ul>
            <li onClick={() => handleQuickLinkClick('products')}>PRODUCTS</li>
            <li onClick={() => handleQuickLinkClick('about')}>ABOUT US</li>
            <li onClick={() => handleQuickLinkClick('bespoke')}>BESPOKE JEWELRY</li>
            <li onClick={() => handleQuickLinkClick('contact')}>CONTACT US</li>
            <li onClick={() => handleQuickLinkClick('terms')}>TERMS & CONDITIONS</li>
          </ul>
        </div>

        {/* Product Categories */}
        <div className="footer-column">
          <h4>Product Categories</h4>
          <ul className="product-categories-grid">
            {productCategories.map((category) => (
              <li key={category} onClick={() => handleProductClick(category)}>
                {category}
              </li>
            ))}
          </ul>
        </div>

        {/* Customer Service */}
        <div className="footer-column customer-service-column">
          <h4>Customer Service</h4>
          <ul>
            <li onClick={() => navigate('/account')}>My Account</li>
            <li onClick={() => navigate('/order')}>Track Order</li>
            <li onClick={() => navigate('/cart')}>Shopping Cart</li>
            <li onClick={() => navigate('/wishlist')}>Wishlist</li>
            <li onClick={() => navigate('/contact')}>Help & Support</li>
          </ul>
          <div className="stay-connected-section">
            <h4>Stay Connected</h4>
            <p>Subscribe to our newsletter for exclusive offers and updates</p>
            <form className="newsletter-form" onSubmit={handleNewsletterSubmit}>
              <div className="newsletter-input-group">
                <input 
                  type="email" 
                  placeholder="Enter your email" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
                <button type="submit">
                  <FaArrowRight />
                </button>
              </div>
            </form>
            
            <div className="social-links">
              <h5>Follow Us</h5>
              <div className="social-icons">
                <a href="https://facebook.com/panchalijewels" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <FaFacebook />
                </a>
                <a href="https://instagram.com/panchalijewels" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <FaInstagram />
                </a>
                <a href="https://linkedin.com/company/panchalijewels" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
                  <FaLinkedin />
                </a>
                <a href="https://twitter.com/panchalijewels" target="_blank" rel="noopener noreferrer" aria-label="Twitter">
                  <FaTwitter />
                </a>
                <a href="https://youtube.com/panchalijewels" target="_blank" rel="noopener noreferrer" aria-label="YouTube">
                  <FaYoutube />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <div className="footer-bottom-left">
            <p>&copy; 2025 <span className="brand-name-gold">Panchali Jewels</span>. All rights reserved.</p>
          </div>
          <div className="footer-bottom-right">
            <Link to="/terms">Privacy Policy</Link>
            <Link to="/terms">Terms of Service</Link>
            <Link to="/terms">Cookie Policy</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
